import { Box, Tooltip } from '@mui/material'
import { useTranslate } from 'react-admin'

import { INFO_WINDOW_TRANSLATION_KEY } from './InfoWindow/AdvancedInfoWindow'

const CircularGaugeIcon = ({ percent, value, thresholds = [], Icon, startAngle = -90 }) => {
  const strokeWidth = 2
  const radius = 12
  const circumference = 2 * Math.PI * radius
  const translate = useTranslate()

  const safePercent = Math.max(0, Math.min(100, percent ?? 100))
  const offset = circumference - (safePercent / 100) * circumference

  let color = '#ccc'
  let tooltipTitle = translate(`${INFO_WINDOW_TRANSLATION_KEY}.noData`)

  if (thresholds.length > 0 && value != null) {
    for (const t of thresholds) {
      if (value <= t.limit) {
        color = t.color
        if (typeof t.label === 'string') {
          tooltipTitle = translate(`${INFO_WINDOW_TRANSLATION_KEY}.${t.label}`)
        } else {
          tooltipTitle = translate(`${INFO_WINDOW_TRANSLATION_KEY}.${t.label.message}`, { ...t.label.options })
        }
        break
      }
    }
  }

  return (
    <Tooltip title={tooltipTitle} placement="right">
      <Box sx={{ position: 'relative', width: 28, height: 28 }}>
        <svg width={28} height={28}>
          <circle cx={14} cy={14} r={radius} stroke="#eee" strokeWidth={strokeWidth} fill="none" />
          <circle
            cx={14}
            cy={14}
            r={radius}
            stroke={color}
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            transform={`rotate(${startAngle} 14 14)`}
            style={{ transition: 'stroke-dashoffset 0.4s ease, stroke 0.3s ease' }}
          />
        </svg>
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon fontSize="small" sx={{ color: '#444' }} />
        </Box>
      </Box>
    </Tooltip>
  )
}

export default CircularGaugeIcon
